(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/device-services/assets/javascripts/web/web-haptic-service.js') >= 0) return;  svs.modules.push('/components/tur/device-services/assets/javascripts/web/web-haptic-service.js');

'use strict';

class WebHapticService {
  vibrate(ms) {
    var _navigator$vibrate, _navigator;
    (_navigator$vibrate = (_navigator = navigator).vibrate) === null || _navigator$vibrate === void 0 || _navigator$vibrate.call(_navigator, ms);
  }

  light() {
    this.vibrate(10);
  }
  medium() {
    this.vibrate(20);
  }
  heavy() {
    this.vibrate(30);
  }
  soft() {
    this.vibrate(10);
  }
  rigid() {
    this.vibrate(15);
  }
  success() {
    this.vibrate(20);
  }
  warning() {
    this.vibrate(30);
  }
  error() {
    this.vibrate(40);
  }
  selectionChanged() {
    this.vibrate(10);
  }
  async trigger(pattern) {
    const items = Array.isArray(pattern) ? pattern : [pattern];
    if (!navigator.vibrate) {
      return;
    }
    const vibratePattern = items.flatMap(item => {
      var _item$delay;
      return [item.duration, (_item$delay = item.delay) !== null && _item$delay !== void 0 ? _item$delay : 0];
    });
    navigator.vibrate(vibratePattern);
  }
}
setGlobal('svs.tur.device.WebHapticService', WebHapticService);

 })(window);